import { DefaultError, useMutation } from "@tanstack/react-query";
import { updateTicketStatus } from "../api/updateTicketStatus";
import {
  invalidateCustomerTicketsQuery,
  QueryTicketsProps,
} from "../queries/useCustomerTicketsDataQuery";
import { TicketStatus } from "../types";

type Params = QueryTicketsProps & {
  ticketId: string;
  status: TicketStatus;
  onMutate: () => void;
};

export const useUpdateTicketStatus = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ ticketId, status }) => {
      await updateTicketStatus(ticketId, status);
    },
    onMutate: ({ onMutate }) => {
      onMutate();
    },
    onSuccess: async (_, { filters, query }) => {
      await invalidateCustomerTicketsQuery({ filters, query });
    },
    onError: (error) => {
      console.error("Error occurred when updating ticket status", error);
    },
  });
};
